<template>
  <div class="header">
    <div class="titleBox">
      <router-link to="/index">
        <img class="icon" src="@/assets/img/zhuye.png" alt="" />
      </router-link>
      <h1 class="title">
        <router-link to="/index">中国金融科技发展指数平台</router-link>
      </h1>
    </div>

    <Marquee v-if="notices.length" class="notic" :notices="notices" />
    <div class="menu-right" style="flex: none">
      <div class="link-our">联系我们 15010254218</div>
      <el-badge
        :value="total0"
        :hidden="Number(total0) === 0"
        class="message"
        style="margin-right: 10px"
        @click.native="$router.push('/message/message')"
      >
        <i class="el-icon-message" />
      </el-badge>
      <el-dropdown trigger="hover" style="width: 143px">
        <div class="user">
          <i class="el-icon-user" />
          <!-- <span class="name">{{ $store.state.user.userInfo.userName }}</span> -->
          <span class="name">个人中心</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="$router.push('/user-manage/center')">
            个人中心
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Marquee from "@/components/Marquee/index.vue";
import { accessAdd } from "@/api/user";
import { formatDateTime } from "@/utils/index";
export default {
  components: {
    Marquee,
  },
  data() {
    return {
      noticeIndex: 0,
    };
  },
  computed: {
    notices() {
      const notices = this.$store.state.notice.notices.map((i) => i.content);
      return notices;
    },
    total0() {
      return this.$store.state.message.total0;
    },
  },
  watch: {
    notices(value) {
    },
    $route: {
      handler: function (route) {
        // 埋点统计
        this.statistics(route);
      },
      immediate: true,
    },
  },
  mounted() {
    // this.$refs.marquee.addEventListener('onfinish', this.noticFinish)
  },
  updated() {
    // this.$refs.marquee.loop = '1'
  },
  created() {
    this.$store.dispatch("notice/getNotices");
    this.$store.dispatch("message/getMessage", { state: "0" });
  },
  methods: {
    logout() {
      // 退出埋点
      let params = {
        meta: {
          title: "退出"
        }
      }
      this.statistics(params);
      this.$store.dispatch("user/logout");
      this.$router.push("/login");
    },
    noticFinish() {
      
    },
    // 埋点统计
    statistics(route) {
      let meta = route.meta;
      let params = {
        operationName: meta.title,
        userId: this.$store.state.user.userInfo.userId,
        loginName: this.$store.state.user.userInfo.loginName,
        realName: this.$store.state.user.userInfo.userName,
        operationTm: formatDateTime(new Date()),
      };
      accessAdd(params).then((resp) => {
      }).catch(err => {
        console.log('err:', err)
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 0 37px 0 37px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(242, 242, 242);
  box-shadow: 0 2px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  .titleBox {
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 16px;
    color: #0071bc;
    flex-shrink: 0;
  }
  .icon {
    // margin-left: 30px;
    margin-right: 20px;
    width: 23px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .notic {
    margin: 0 30px;
    // width: 588px;
    width: 709px;
    line-height: 30px;
    font-size: 16px;
    color: #000000;
    // border: 2px solid #0071bc;
  }
  .menu-right{
    display: flex;
    align-items: center;
    
  }
  .link-our{
    padding:15px;
    color:#0071bc;
  }
  .message {
    cursor: pointer;
  }
  .user {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: flex-end;
  }
  .el-icon-user {
    margin-right: 5px;
    color: #0071bc;
    font-size: 26px;
    line-height: 45px;
  }
  .name {
    font-size: 16px;
    line-height: 45px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .empty {
    // flex: 1;
  }
}
</style>
